"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@cian/peperrors/shared");
var utils_1 = require("./utils");
var envelope_1 = require("./envelope");
// tslint:disable-next-line:no-any
function ensureErrorIsError(error) {
    return error instanceof Error || error instanceof shared_1.GenericError ? error : new Error(String(error));
}
/**
 * @description базовая реализация логгера. Класс реализует стандартные методы
 * и методы для разбора ошибок.
 *
 * @export
 * @class BaseLogger
 * @implements {ILogger}
 */
var BaseLogger = /** @class */ (function () {
    function BaseLogger(config) {
        this.messageWriter = config.messageWriter;
        this.errorWriter = config.errorWriter;
        this.application = config.application;
        this.version = config.version;
        this.errorType = config.errorType;
        this.messageType = config.messageType;
    }
    /**
     * @description метод для дебага приложения.
     *
     * @param {string} message - сообщение для дебага
     * @param {TMeta} [meta] - объект, который может содержать любую мета-информацию
     * @memberof ILogger
     */
    BaseLogger.prototype.debug = function (message, meta) {
        this.messageWriter.write(this.prepareMessageEnvelope('debug', message, meta));
    };
    /**
     * @description метод для информационных сообщений.
     *
     * @param {string} message - информационное сообщение
     * @param {TMeta} [meta] - объект, который может содержать любую мета-информацию
     * @memberof ILogger
     */
    BaseLogger.prototype.info = function (message, meta) {
        this.messageWriter.write(this.prepareMessageEnvelope('info', message, meta));
    };
    /**
     * @description метод для предупреждений.
     *
     * @param {string} message - сообщение предупреждения
     * @param {TMeta} [meta] - объект, который может содержать любую мета-информацию
     * @memberof ILogger
     */
    BaseLogger.prototype.warning = function (message, meta) {
        this.messageWriter.write(this.prepareMessageEnvelope('warning', message, meta));
    };
    /**
     * @description метод для логирования ошибок.
     * Если `error` объект, который наследуется от класса `Error`, то объект будет разбираться самостоятельно.
     * Метод из ошибки и меты формирует JSON, который в последствии он будет отображен в ELK.
     *
     * @example
     *  logger.error(new Error('Example'), { meta: 'info' });
     *  // Логгер разберет ошибку (первый аргумент). В ЕЛК будет JSON с такими полями:
     *  {
     *    name: error.name,
     *    message: error.message,
     *    stack: error.stack
     *    meta: [{ key: 'meta', value: 'info' }],
     *  }
     *
     * @param {(string | Error | GenericError)} error - сообщение или объект ошибки,
     * который должен быть имплентацией {Error}.
     * @param {TMeta} [meta] - объект, который может содержать любую мета-информацию
     * @memberof ILogger
     */
    BaseLogger.prototype.error = function (error, meta) {
        this.errorWriter.write(this.prepareErrorEnvelope(ensureErrorIsError(error), meta));
    };
    BaseLogger.prototype.prepareMessageEnvelope = function (level, message, meta) {
        return {
            type: this.messageType,
            level: level,
            message: message,
            date: (new Date()).toISOString(),
            application: this.application,
            version: this.version,
            meta: meta ? utils_1.convertMetaToKeyValue(meta) : [],
        };
    };
    BaseLogger.prototype.prepareErrorEnvelope = function (error, meta) {
        var params = {
            application: this.application,
            type: this.errorType,
            version: this.version,
        };
        return error instanceof shared_1.GenericError
            ? envelope_1.createEnvelopeFromPeperror(params, error, meta)
            : envelope_1.createEnvelopeFromNativeError(params, error, meta);
    };
    return BaseLogger;
}());
exports.BaseLogger = BaseLogger;
//# sourceMappingURL=baseLogger.js.map